import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DrawerModule } from 'primeng/drawer';

@Component({
    selector: 'sidebar',
    imports: [DrawerModule, TranslateModule],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarCustomComponent {
    isVisible = model.required<boolean>();
    id = input.required<string>();

    title = input<string | null>(null);
    position = input<'right' | 'left' | 'bottom' | 'top'>('right');
    showCloseIcon = input<boolean>(true);
    blockScroll = input<boolean>(true);
    closeOnEscape = input<boolean>(true);
    modal = input<boolean>(true);
}
